import { Dtos, formatToDollar, formatToPercent } from "@inrev/common";
import { AdminSuretyBond } from "@portal/api/bond/admin";
import { AdminBondRequest } from "@portal/api/bond-request/admin/types";
import { Card } from "@portal/components/ui/Card";
import { formatFromISODate } from "../../../utils";
import { isFieldPartial } from "../../../utils/schema-fields";
import { AdminDataList, AdminDataListProps } from "../../shared/admin/AdminDataList";
import { ViewSectionLayout } from "../../shared/layouts/ViewSectionLayout";

type AdminBondRequestBidResultsCardProps = {
	request: AdminBondRequest;
	bidBond: AdminSuretyBond | undefined;
	underwriting: Dtos.Admin.Quote.Underwriting | null | undefined;
};

const schema = Dtos.Admin.SuretyQuote.Contract.BidToFinal.Update.Request.schema;

export const AdminBondRequestBidResultsCard = ({
	request,
	bidBond,
	underwriting,
}: AdminBondRequestBidResultsCardProps) => {
	const data = (() => {
		const data: AdminDataListProps["data"] = [];

		if (request.contractSuretyType === "bid_to_final") {
			data.push({
				label: "Low Bid (Principal's Bid)",
				value: formatToDollar(request.actualBidAmount),
				partial: isFieldPartial(schema, "actualBidAmount"),
			});
			data.push({
				label: "Second Lowest Bid",
				value: formatToDollar(request.secondBid),
				partial: isFieldPartial(schema, "secondBid"),
			});
			if (bidBond !== undefined && bidBond.contractSuretyType === "bid") {
				data.push({
					label: "Requested Bid Amount",
					value: formatToDollar(bidBond.bidAmount),
				});
			}
			data.push({
				label: "Contract Amount",
				value: formatToDollar(request.contractAmount),
				partial: isFieldPartial(schema, "contractAmount"),
			});
			data.push({
				label: "Bid Date",
				value: formatFromISODate(request.actualBidDate),
				partial: isFieldPartial(schema, "actualBidDate"),
			});
			data.push({
				label: "Contract Date",
				value: formatFromISODate(request.contractDate),
				partial: isFieldPartial(schema, "contractDate"),
			});
			if (underwriting?.contractSuretyType === "bid_to_final") {
				data.push({
					label: "Bid Spread",
					value: formatToPercent(underwriting.bond.calculations.bidSpread),
				});
				data.push({
					label: "Actual Bid / Requested Bid",
					value: formatToPercent(underwriting.bond.calculations.actualToRequestedBidSpread),
				});
				data.push({
					label: "Days From Bid Date To Contract Date",
					value: underwriting.bond.calculations.daysFromBidToContractDate,
				});
			}
		}

		return data;
	})();

	return (
		<ViewSectionLayout header="Bid Results" partial={false} partialActive={false}>
			<Card>
				<div className="w-full px-[33px] py-[26px]">
					<AdminDataList data={data} />
				</div>
			</Card>
		</ViewSectionLayout>
	);
};
